import React from 'react';
import { useState, useContext } from 'react';
import RickMortyContext from '../../context/RickMortyContext';
import CharacterItem from '../characters/CharacterItem';
import CharacterModal from '../characters/CharacterModal';

function Bookmark() {
  const { bookmarks, openModal } = useContext(RickMortyContext);
  const [showBookmarks, setShowBookmarks] = useState(false);

  return (
    <div>
      <button
        className={`btn bookmarks__btn ${showBookmarks ? 'active' : ''}`}
        onClick={() => setShowBookmarks(!showBookmarks)}
      >
        Bookmarks
      </button>

      <div className="bookmarks">
        {showBookmarks &&
          bookmarks.map((character) => (
            <CharacterItem
              key={character.id}
              character={character}
              handleDetail={() => openModal(character.id)}
            />
          ))}
      </div>
      <CharacterModal />
    </div>
  );
}

export default Bookmark;
